
import { PropType, computed, defineComponent, ref } from 'vue';

import { Files } from '../models';

export default defineComponent({
  name: 'InformationFileItem',
  props: {
    file: {
      type: Object as PropType<Files>,
      required: true,
    },
    isLastItem: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const loading = ref(false);

    const haveFileUrl = computed(() => !!props.file.url);

    const haveDescription = computed(() => !!props.file.description);

    const downloadFile = () => {
      loading.value = true;
      window.open(props.file.url, '_blank', 'noopener,noreferrer');
      setTimeout(() => {
        loading.value = false;
      }, 750);
    };

    return {
      haveFileUrl,
      haveDescription,
      downloadFile,
      loading,
    };
  },
});
